import {
  Box,
  Button,
  Divider,
  Stack,
  styled,
  Typography,
  Zoom,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import Allocation from "./Allocation";
import { useState } from "react";
import EmployeeFileUploader from "./EmployeeFileUploader";
import ClientFileUploader from "./ClientFileUploader";

function FileUploader(props) {
  const { stageChanger } = props;
  const [employeeColor, setEmployeeColor] = useState("info");
  const [clientColor, setclientColor] = useState("info");
  const [form, setForm] = useState(<EmployeeFileUploader />);

  const handleClient = () => {
    setForm(<ClientFileUploader stageChanger={stageChanger}/>);
    setclientColor("info");
    setEmployeeColor(blue[100]);
  };

  const handleEmployee = () => {
    setForm(<EmployeeFileUploader stageChanger={stageChanger}/>);
    setEmployeeColor("info");
    setclientColor(blue[100]);
  };

  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
          <Typography variant="h6">Upload Files</Typography>
          <Divider variant="middle" />
          <Box display={"flex"} justifyContent={"space-evenly"} my={2}>
            <Button
              variant="contained"
              size="small"
              color={employeeColor}
              sx={{ borderRadius: 4 }}
              onClick={handleEmployee}
            >
              Employees
            </Button>
            <Button
              variant="contained"
              size="small"
              color={clientColor}
              sx={{ borderRadius: 4 }}
              onClick={handleClient}
            >
              Clients
            </Button>
          </Box>
          <Divider variant="middle" />
          {form}
        </Stack>
      </Zoom>
    </>
  );
}

export default FileUploader;
